import { service, handler, getJSON } from "service";

import { StringMap, Credentials, SendStepData, GetRegistrationResp } from "./types/types.js";

export const additionalRegistration = async (data: SendStepData, servicePath: string) =>
  await service(servicePath)("Account", "additionalRegister")(data);

export const checkCredentials = async (data: Credentials, servicePath: string) =>
  await service(servicePath)("Account", "checkCredentials")(data);

export const getLobbyFiles = async (data: StringMap<string | number>, servicePath: string) =>
  await service(servicePath)("Lobby", "getLobbyFiles")(data);

export const getLocale = async (servicePath: string, locale: string) => {
  const localePath = '/locale/strings/' + locale + '/context/registration/strings.bin';
  const [strings] = await Promise.all([handler(servicePath, true)(localePath)("")])
  return strings.strings;
}

export const getUserInfo = async (hash: string, servicePath: string) =>
  await service(servicePath)("Account", "getUserInfo")({ hash });

export const getRegistrationFormData = async (
  data: StringMap<string | number>,
  path: string
): Promise<GetRegistrationResp> => await service(path)("Account", "getRegistrationFormData")(data);

export const getRequiredFields = async (hash: string, servicePath: string, location?: "cashier" | "signup", mode?: boolean) =>
  await service(servicePath)("Account", "getRequiredFields")(mode ? {
    hash,
    client: "fields",
    location: "cashier",
    mode,
  } : { hash, client: "fields", location: "cashier" });

export const postFormData = async (data: SendStepData, mode: string, servicePath: string) =>
  await service(servicePath)("Account", `register${mode}`)(data);

export const validateEmailCode = async (email: string, code: string | number, servicePath: string) =>
  await service(servicePath)("Account", "verifyCode")({ email, code });

export const resendVerificationEmail = async (email: string, servicePath: string, withCode = true) =>
  await service(servicePath)("Account", "resendVerificationEmail")({ email, withCode });

export const registerReal = async (data: SendStepData, servicePath: string) =>
  await postFormData(data, "Real", servicePath);

export const registerFun = async (data: SendStepData, servicePath: string) =>
  await postFormData(data, "Fun", servicePath);

export const reportError = async (
  hash: string | null,
  serviceType: string,
  type: string,
  message: typeof type,
  servicePath: string
) =>
  await service(servicePath)("Lobby", "reportError")({
    hash,
    service: serviceType,
    message: type,
    received: message,
  });

export const transFile = (path: string, file: string, checksum = null) =>
  !checksum ? `${path}/${file}` : `${path}/${file}?checksum=${checksum}`;

export const sendSMS = async (phoneNumber: string | number, servicePath: string) =>
  await service(servicePath)("SMS", "attemptVerification")({ phoneNumber });

export const verifySMS = async (
  phoneNumber: string | number,
  code: string | number,
  servicePath: string
) => await service(servicePath)("SMS", "verifyCode")({ phoneNumber, code });
